import { forwardRef, memo } from "react";
import classnames from "classnames";
import { StepBase } from "../../StepBase";
import { ProgressStepItem, ProgressStepProps } from "../types";
import { getIndicatorState } from "../utils";

import styles from "./style.module.scss";

export type ProgressTextWithTextProps = ProgressStepProps & {
  connector?: boolean;
};

export const ProgressIconsWithText = memo(
  forwardRef<HTMLDivElement, ProgressTextWithTextProps>(
    (
      {
        size = "sm",
        steps,
        connector = true,
        className,
        currentStep = 0,
        ...props
      },
      ref,
    ) => {

      return (
        <div
          className={classnames(styles.root, className, styles[size as keyof typeof styles])}
          {...props}
          ref={ref}
        >
          {steps?.map((item: ProgressStepItem, index: number) => {
            const isLastStep = index === steps.length - 1;
            return (
              <StepBase
                {...item}
                id={`${item?.id}`}
                key={item.id}
                size={size}
                connector={!isLastStep && connector}
                type={item.icon ? "featuredIconLeft" : "iconLeft"}
                status={getIndicatorState(index, currentStep)}
              />
            );
          })}
        </div>
      );
    },
  ),
);
